import { z } from "zod";

/** POST /v1/tasks/:id/review — K-076: yalnızca tamamlanmış işe, işin tarafı, bir kez */
export const CreateReviewBody = z.union([
  /** müşteri → hizmet veren: 1–5 yıldız, açık yorum */
  z.object({
    rating: z.number().int().min(1).max(5),
    comment: z.string().trim().max(2000).optional(),
    commentLocale: z
      .string()
      .regex(/^[a-z]{2}$/)
      .optional(),
  }),
  /** hizmet veren → müşteri: gizli başparmak (K-037 benzeri iç sinyal) */
  z.object({ thumbs: z.enum(["up", "down"]), comment: z.string().trim().max(1000).optional() }),
]);
export type CreateReviewBody = z.infer<typeof CreateReviewBody>;

/** PUT /v1/provider/reviews/:id/reply — K-065: bir açık cevap, düzenlenebilir */
export const ReviewReplyBody = z.object({ body: z.string().trim().min(2).max(1000) });

/** POST /v1/reviews/:id/report — K-076, K-083 */
export const ReportContentBody = z.object({
  reason: z.enum([
    "abuse",
    "personal_info",
    "wrong_task",
    "discrimination",
    "extortion",
    "illegal",
    "other",
  ]),
  details: z.string().trim().max(1000).optional(),
});

export interface PublicReview {
  id: string;
  rating: number;
  comment: string | null;
  author: string;
  service: string | null;
  createdAt: string;
  reply: { body: string; at: string } | null;
}
